// extracted by mini-css-extract-plugin
var _1 = "KWF8L";
var _2 = "mudNk";
export { _1 as "base", _2 as "tz" }
